import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import soldeService from "../services/soldeService";
const initialState = {
    soldes: [],
    soldesFournisseur: [],
    loading: false,
    error: null,
};

const soldeSlice = createModule({
    name: 'soldes',
    initialState,
    reducers: {
        search: (state) => {
            state.loading = true;
            state.error = null;
        },
        
        searchChantier: (state) => {
            state.loading = true;
            state.error = null;
        },
        searchFournisseur: (state) => {
            state.loading = true;
            state.error = null;
        },
        searchCommercial: (state) => {
            state.loading = true;
            state.error = null;
        },
        deleteClientMovement: (state) => {
            state.loading = true;
            state.error = null;
        },
        deleteSupplierMovement: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchedData: (state, action) => {
            state.soldes = action;
            state.loading = false;
        },
        fetchedDataFournisseur: (state, action) => {
            console.log(action);
            state.soldesFournisseur = action;
            state.loading = false;
        },
        fetchError: (state) => {
            state.loading = false;
            state.error = true;
        },
        finishFetching: (state) => {
            state.loading = false;
        },
    },
    sagas: (A) => ({
        *[A.search]({ payload }) {
            try {
                const { data } = yield call(soldeService.search, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
                if (payload.onSuccess) {
                    yield call(payload.onSuccess, data);
                }
            } catch (e) {
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        
        *[A.searchChantier]({ payload }) {
            try {
                const { data } = yield call(soldeService.searchChantier, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
            } catch (e) {
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.searchFournisseur]({ payload }) {
            try {
                const { data } = yield call(soldeService.searchFournisseur, payload);
                console.log(data)
                yield put(A.finishFetching());
                yield put(A.fetchedDataFournisseur(data));
            } catch (e) {
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.searchCommercial]({ payload }) {
            try {
                const { data } = yield call(soldeService.searchCommercial, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
            } catch (e) {
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.deleteClientMovement]({ payload }) {
            try {
                yield call(soldeService.deleteClientMovement, payload.id);
                yield put(A.finishFetching());
                if (payload.onSuccess) yield call(payload.onSuccess);
            } catch (e) {
                yield put(A.fetchError());
                if (payload.onError) yield call(payload.onError, e);
            }
        },
        *[A.deleteSupplierMovement]({ payload }) {
            try {
                yield call(soldeService.deleteSupplierMovement, payload.id);
                yield put(A.finishFetching());
                if (payload.onSuccess) yield call(payload.onSuccess);
            } catch (e) {
                yield put(A.fetchError());
                if (payload.onError) yield call(payload.onError, e);
            }
        },
    }),
});

export default soldeSlice;
export const soldeActions = soldeSlice.actions;
